import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleTextArea, SingleText, SingleInput, SingleMultilineText, SingleSelect } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { getval2Token, getTexIdNumber } from '../../../Login/Auth';
import { RespCustomerPositionInfo, RespCustomerPosition, WageType_Arr, JobDemand_Arr, ReqCustomerPositionDetail, RespCustomerPositionInfo_WageInfo_WageType1, WageType1, WageType2, RespCustomerPositionInfo_WageInfo_WageType2, RespCustomerPositionInfo_WageInfo_WageType3, WageType3, WageType0, LaborInsuranceType_Arr, GroupInsuranceType_Arr, InsuranceSOPType_Arr, DateOfInsurance_Arr, RespCustomerPositionInfo_Insurance } from '../../../../item/ItemCustomerPosition';
import { api_addCustomerPosition, api_getCustomerPositionDetail } from '../../../../api/apiCustomerPosition';
import { getItemsInfo } from '../../../../item/ItemTools';
import { ItemWageTypeInfo1 } from './ItemWageTypeInfo1';
import { ItemWageTypeInfo2 } from './ItemWageTypeInfo2';
import { ItemWageTypeInfo3 } from './ItemWageTypeInfo3';
import { api_getLaborInsuranceLevel_Arr, api_getHealthInsuranceLevel_Arr } from '../../../../api/apiOpenData';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { ItemInsurance } from './ItemInsurance';


export function CustomerPositionEdit({ id, setIsLoading, isAdd = false, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  const [info, setInfo] = useState({})
  const [job, setJob] = useState("")
  const [shift, setShift] = useState("")
  const [workPlace, setWorkPlace] = useState("")
  const [workAddress, setWorkAddress] = useState("")
  const [jobRequirement, setJobRequirement] = useState("")
  const [jobDemand, setJobDemand] = useState("")
  const [wageType, setWageType] = useState(WageType0)
  const [wageInfo, setWageInfo] = useState("")
  const [insuranceInfo, setInsuranceInfo] = useState("")

  const [wageInfo_WageType1, setWageInfo_WageType1] = useState(new RespCustomerPositionInfo_WageInfo_WageType1({}))
  const [wageInfo_WageType2, setWageInfo_WageType2] = useState(new RespCustomerPositionInfo_WageInfo_WageType2({}))
  const [wageInfo_WageType3, setWageInfo_WageType3] = useState(new RespCustomerPositionInfo_WageInfo_WageType3({}))
  const [insurance, setInsurance] = useState("")

  const [wageType_Obj, setWageType_Obj] = useState(<></>)

  const [init, setInit] = useState(true)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("customerPosition", id)
      // console.log(obj)
      // var cId = getval2Token("customerContractId", id)
      setCustomerContractId(obj.customerContractId)
      setTokenId(id)
      if (!isAdd) {
        // var pId = getval2Token("customerPositionId", id)
        setCustomerPositionId(obj.customerPositionId)
      }
    }
  }, [id])

  useEffect(() => {
    if (customerPositionId !== undefined && customerPositionId !== "") {
      setIsLoading(true)
      var mReqCustomerPositionDetail = new ReqCustomerPositionDetail({
        customerPositionId,
        customerContractId
      })
      getDetail(mReqCustomerPositionDetail)
    } else {
    }
  }, [customerPositionId])

  useEffect(() => {
    if (wageType !== WageType0)
      setWageInfo(wageInfo_WageType1)
  }, [wageInfo_WageType1])
  useEffect(() => {
    if (wageType !== WageType0)
      setWageInfo(wageInfo_WageType2)
  }, [wageInfo_WageType2])
  useEffect(() => {
    if (wageType !== WageType0)
      setWageInfo(wageInfo_WageType3)
  }, [wageInfo_WageType3])

  useEffect(() => {
    if (init)
      return
    console.log("wageType")
    console.log(wageInfo)
    //console.log(WageType0)
    switch (wageType) {
      case WageType0:
        setWageInfo({})
        setInsuranceInfo({})
        setInsurance({})
        break;
      case WageType1:
        setInsuranceInfo(new RespCustomerPositionInfo_Insurance({}))
        setInsurance(new RespCustomerPositionInfo_Insurance({}))
        wageTypeChange(wageType)
        break;
      case WageType2:
        setInsuranceInfo(new RespCustomerPositionInfo_Insurance({}))
        setInsurance(new RespCustomerPositionInfo_Insurance({}))
        wageTypeChange(wageType)
        break;
      case WageType3:
        setInsuranceInfo({})
        wageTypeChange(wageType)
        break;
      default:
        break;
    }

  }, [wageType])

  useEffect(() => {
    if (!init)
      return
    if (Object.keys(wageInfo).length > 0) {
      wageTypeChange(wageType, wageInfo)
      // console.log(wageInfo)
      if (init) {
        setInit(false)
      }
    }
  }, [wageInfo])

  function getDetail(mReqCustomerPositionDetail) {
    // console.log(mReqCustomerPositionDetail)
    api_getCustomerPositionDetail({
      mReqCustomerPositionDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespCustomerPosition = new RespCustomerPosition({})
        mRespCustomerPosition.fromJson(jsonData.detail)
        console.log(mRespCustomerPosition)

        setJob(mRespCustomerPosition.info.job)
        setShift(mRespCustomerPosition.info.shift)
        setWorkPlace(mRespCustomerPosition.info.workPlace)
        setWorkAddress(mRespCustomerPosition.info.workAddress)
        setJobRequirement(mRespCustomerPosition.info.jobRequirement)
        setJobDemand(mRespCustomerPosition.info.jobDemand)
        setWageType(mRespCustomerPosition.info.wageType)
        setWageInfo(mRespCustomerPosition.info.wageInfo)
        setInsuranceInfo(mRespCustomerPosition.info.insuranceInfo)
        setInsurance(mRespCustomerPosition.info.insuranceInfo)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toEdit() {
    window.location.assign("/CustomerPositionEdit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    if (customerContractId === undefined || customerContractId === "") {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '參數失效, 請重新進入',
      }).then(function () {
        toCancel()
      })
      return
    }

    var inputError = []
    if (job === "") {
      inputError.push("職稱")
    }
    if (shift === "") {
      inputError.push("班別名稱")
    }
    // if (workPlace === "") {
    //   inputError.push("工作地點")
    // }
    // if (workAddress === "") {
    //   inputError.push("工作地址")
    // }
    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    var mRespCustomerPositionInfo = new RespCustomerPositionInfo({
      job,                //職稱
      shift,              //班別名稱
      workPlace,          //工作地點
      workAddress,        //工作地址
      jobRequirement,     //招募條件
      jobDemand,          //職缺需求量
      wageType,           //服務費計算方式
      wageInfo,            //服務費計算內容
      insuranceInfo
    })

    var mRespCustomerPosition = new RespCustomerPosition({
      customerContractId,
      customerPositionId,
      info: JSON.stringify(mRespCustomerPositionInfo),
    })

    console.log(mRespCustomerPositionInfo)
    console.log(mRespCustomerPosition)

    api_addCustomerPosition({
      mRespCustomerPosition,
      success: (jsonData) => {
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: customerPositionId === "" ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function wageTypeChange(val, item) {
    // console.log("wageTypeChange")
    // console.log(val)
    // console.log(isEdit)
    setWageType(val)
    switch (val) {
      case WageType1:
        setWageType_Obj(<ItemWageTypeInfo1 item={item || wageInfo_WageType1} action={setWageInfo_WageType1} isEdit={isEdit} />)
        break;
      case WageType2:
        setWageType_Obj(<ItemWageTypeInfo2 item={item || wageInfo_WageType2} action={setWageInfo_WageType2} isEdit={isEdit} />)
        break;
      case WageType3:
        setWageType_Obj(<ItemWageTypeInfo3 item={item || wageInfo_WageType3} action={setWageInfo_WageType3} isEdit={isEdit} />)
        break;
      default:
        setWageType_Obj(<></>)
        break;
    }
  }

  useEffect(() => {
    //console.log(wageType_Obj)
  }, [wageType_Obj])

  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]

  const isPublicItems = [
    { "val": 1, "name": "是" },
    { "val": 0, "name": "否" },
  ]

  var title = "職缺資訊"
  var title_tools =
    <>
      {isEdit ? <></> :
        <a className="dropdown-toggle " onClick={e => toEdit()} data-toggle="dropdown" href="#A">
          <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
        </a>
      }
    </>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>招募資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleInput title={"職稱"}
                val={job}
                action={setJob}
                placeholder={"技術員"}
              />
              :
              <SingleText title={"職稱"} val={job} />
          }
          {
            isEdit ?
              <SingleInput title={"班別名稱"}
                val={shift}
                action={setShift}
                placeholder={"日班"}
              />
              :
              <SingleText title={"班別名稱"} val={shift} />
          }
          {
            isEdit ?
              <SingleInput title={"工作地點"}
                val={workPlace}
                action={setWorkPlace}
                placeholder={"信義一點/五股廠房"}
              />
              :
              <SingleText title={"工作地點"} val={workPlace} />
          }
          {
            isEdit ?
              <SingleInput title={"工作地址"}
                val={workAddress}
                action={setWorkAddress}
                placeholder={"新北市五股區五工路200號"}
              />
              :
              <SingleText title={"工作地址"} val={workAddress} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleTextArea title={"招募條件"} val={jobRequirement} action={setJobRequirement} rows={5} />
              :
              <SingleMultilineText title={"招募條件"} val={jobRequirement} size={12} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleSelect title={"服務費計算方式"}
              val={wageType}
              attr={WageType_Arr}
              action={wageTypeChange}
              hasBlank={true}
              blankVal={WageType0}
            />
            : <SingleText title={"服務費計算方式"} val={getItemsInfo({ items: WageType_Arr, val: wageType })} />
          }
          {isEdit ?
            <SingleSelect title={"職缺需求量"}
              val={jobDemand}
              attr={JobDemand_Arr}
              action={setJobDemand}
              hasBlank={true}
            />
            : <SingleText title={"職缺需求量"} val={getItemsInfo({ items: JobDemand_Arr, val: jobDemand })} />
          }
        </div>
      </div>
      {wageType_Obj}

      {
        (wageType === WageType0 || wageType === WageType3) ? <></> :
          <ItemInsurance item={insurance} action={setInsuranceInfo} isEdit={isEdit} />
      }
    </>

  var footer =
    <div className="row">
      {
        !isEdit ? <></> :
          <div className="col-sm-3 col-sm-offset-9">
            <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
          </div>
      }
    </div>

  return (
    <>
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer} hasDrawer={false} />
      <ManagementPrompt />
      <SystemPromptInput />
    </>
  )
}